import { Permission } from 'entities/user';
import { AppState } from '../AppTypes';
import { _hasPermissionsAll } from './hasPermissionsAll';

export const _hasPermission = (state: AppState) => {
  return (permission: Permission) => {
    return _hasPermissionsAll(state)([permission]);
  };
};
